import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiAdminSiteManager } from '../../enums/api-admin-site-manager.enum';
import { GenericConstants } from '../../enums/generic-constants.enum';
import { SiteCurrencies } from '../../models/site-settings/site-currencies';
import { SiteLanguageRequest } from '../../models/site-settings/site-language';
import { MasterLanguage } from '../../models/site-settings/master-language';
import { SiteInfo } from '../../models/site-settings/site-info-model';
import { SocialMediaConfigRequest } from '../../models/site-settings/social-media-config-request';
import { PaymentMethodsRequest } from '../../models/site-settings/payment-methods-request';
import { SiteCustomDomainRequest } from '../../models/site-settings/site-custom-domain-rq';
import { AvailableAdsPixel } from '../../models/site-settings/available-ads-pixel';
import { AdsPixelModel } from '../../models/site-settings/ads-pixel-model';
import { AdsPixelBody } from '../../models/site-settings/ads-pixel-body';


@Injectable({
  providedIn: 'root'
})
export class SiteSettingService {

  constructor(private http: HttpClient) { }

  //get shop info
  getShopInfo(siteId) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SHOP_INFO;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  //Update Shop info
  updateShopInfo(siteId: string, shopInfo: SiteInfo) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SHOP_INFO;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(shopInfo), {
      headers: headers,
    });
  }

  //get availbale payment methods
  getAvailablePaymentMethods() {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      ApiAdminSiteManager.AVAILABLE_PAYMENT_METHODS;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  //get shop payment methods
  getPaymentMethods(siteId: string) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.PAYMENT_METHODS;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  //save shop payment methods config
  updateShopPaymentMethods(
    siteId: string,
    paymentConfig: PaymentMethodsRequest
  ) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.PAYMENT_METHODS;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    //localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN )
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);
    return this.http.post(url, JSON.stringify(paymentConfig), {
      headers: headers,
    });
  }

  //get shop shipping methos
  getShopShippingMethods(siteId: string) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SHIPPING_METHODS;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  //add new shipping method
  addNewShippingMetho(siteId: string, shippingMethod: any) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SHIPPING_METHODS;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);
    return this.http.post(url, JSON.stringify(shippingMethod), {
      headers: headers,
    });
  }

  //update edit shipping method
  updateShippingMethods(siteId: string, shippingMethod: any) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SHIPPING_METHODS;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(shippingMethod), {
      headers: headers,
    });
  }

  //delete shipping method
  deleteShippingMethod(siteId: string, shippingId: string) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SHIPPING_METHODS +
      '/' +
      shippingId;
    let headers = new HttpHeaders({
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.delete(url, { headers: headers });
  }

  //get site setting social media config
  getSocialMediaConfig(siteId: string) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SOCIAL_MEDIA_CONFIG;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  //update site setting social media config
  updateSocialMediaConfig(
    siteId: string,
    mediaConfig: SocialMediaConfigRequest
  ) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SOCIAL_MEDIA_CONFIG;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(mediaConfig), {
      headers: headers,
    });
  }
  
  //Get site currency
  getSiteCurrency(siteId:string){
    let url = environment.baseUrl + ApiAdminSiteManager.SITE_SETTING + siteId + ApiAdminSiteManager.SITE_CURRENCY;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  //Update site currency
  updateSiteCurrencies(siteId, siteCurrency:SiteCurrencies){
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SITE_CURRENCY;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(siteCurrency), {
      headers: headers,
    });
  }

  //Get platform master language catalog (enabled languages only)
  getMasterLanguages(): Observable<MasterLanguage[]> {
    let url = environment.baseUrl + 'master/language';
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get<MasterLanguage[]>(url, { headers: headers });
  }

  //Get site language settings
  getSiteLanguage(siteId:string){
    let url = environment.baseUrl + ApiAdminSiteManager.SITE_SETTING + siteId + ApiAdminSiteManager.SITE_LANGUAGE;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  //Update site language settings
  updateSiteLanguage(siteId:string, siteLanguage:SiteLanguageRequest){
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.SITE_LANGUAGE;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(siteLanguage), {
      headers: headers,
    });
  }

  //Get Custom domain
  getSiteDomain(siteId:string){
    let url = environment.baseUrl + ApiAdminSiteManager.SITE_SETTING + siteId + ApiAdminSiteManager.CUSTOM_DOMAIN;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  SaveSiteDomain(
    siteId: string,
    customDomain: SiteCustomDomainRequest
  ) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.CUSTOM_DOMAIN;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    //localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN )
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);
    return this.http.post(url, JSON.stringify(customDomain), {
      headers: headers,
    });
  }

  //delete shipping method
  deleteCustomDomain(siteId: string) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.CUSTOM_DOMAIN;
    let headers = new HttpHeaders({
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.delete(url, { headers: headers });
  }

 updateShopStatus(siteId:string,shopStatus:SiteInfo.StatusTypeEnum){
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING + siteId + ApiAdminSiteManager.STATUS + "?status=" + shopStatus;
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem(GenericConstants.STORAGE_ACCESS_TOKEN),
    });
    return this.http.patch(url, "",{  headers: headers })
  }

  getAvailableAdsPixel(){
    let url = environment.baseUrl + ApiAdminSiteManager.SITE_SETTING + ApiAdminSiteManager.AVAILABLE_ADS_PIXEL;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  getShopAdsPixel(siteId:string){
    let url = environment.baseUrl + ApiAdminSiteManager.SITE_SETTING + siteId + ApiAdminSiteManager.ADS_PIXEL;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  updateShopAdsPixel(siteId:string, shopPixels:AdsPixelBody)
  {
  
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.ADS_PIXEL;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(shopPixels), {
      headers: headers,
    });
  }

  // Google Analytics methods
  getShopGoogleAnalytics(siteId: string) {
    let url = environment.baseUrl + ApiAdminSiteManager.SITE_SETTING + siteId + ApiAdminSiteManager.GOOGLE_ANALYTICS;
    let bearToken = localStorage.getItem(
      GenericConstants.STORAGE_ACCESS_TOKEN
    ) as string;
    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', bearToken);

    return this.http.get(url, { headers: headers });
  }

  updateShopGoogleAnalytics(siteId: string, googleAnalytics: any) {
    let url =
      environment.baseUrl +
      ApiAdminSiteManager.SITE_SETTING +
      siteId +
      ApiAdminSiteManager.GOOGLE_ANALYTICS;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem(
        GenericConstants.STORAGE_ACCESS_TOKEN
      ),
    });
    return this.http.put(url, JSON.stringify(googleAnalytics), {
      headers: headers,
    });
  }
}
      

